var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3867 10.8967C19.7817 10.7007 20.8557 9.50473 20.8587 8.05573C20.8587 6.62773 19.8177 5.44373 18.4527 5.21973",
    stroke: "#4D4E4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2285 14.2505C21.5795 14.4525 22.5225 14.9255 22.5225 15.9005C22.5225 16.5715 22.0785 17.0075 21.3605 17.2815",
    stroke: "#4D4E4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3867 14.6641C9.17273 14.6641 6.42773 15.1511 6.42773 17.0961C6.42773 19.0401 9.15573 19.5411 12.3867 19.5411C15.6007 19.5411 18.3447 19.0591 18.3447 17.1131C18.3447 15.1671 15.6177 14.6641 12.3867 14.6641Z",
    stroke: "#4D4E4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3874 11.888C14.4964 11.888 16.2064 10.179 16.2064 8.069C16.2064 5.96 14.4964 4.25 12.3874 4.25C10.2784 4.25 8.56839 5.96 8.56839 8.069C8.56039 10.171 10.2574 11.881 12.3594 11.888H12.3874Z",
    stroke: "#4D4E4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38606 10.8967C4.99006 10.7007 3.91706 9.50473 3.91406 8.05573C3.91406 6.62773 4.95506 5.44373 6.32006 5.21973",
    stroke: "#4D4E4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.544 14.2505C3.193 14.4525 2.25 14.9255 2.25 15.9005C2.25 16.5715 2.694 17.0075 3.412 17.2815",
    stroke: "#4D4E4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupsIcon);
export default __webpack_public_path__ + "static/media/GroupsIcon.4a5d463aa0c4f72cc45d119ed19e06b5.svg";
export { ForwardRef as ReactComponent };